<template>
  <div class="pageStyle">
    <div v-show="!isEmpty">
      <div class="header">
        <div>客户资料</div>
        <div>请补充您的申请信息</div>
      </div>
      <div class="content">
        <div class="input-form">
          <van-form @submit="onSubmit">
            <van-field name="uploader" label="身份证人像面">
              <template #input>
                <van-uploader
                  v-model="form.idCardFront"
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'idCardFront')"
                  :before-delete="(file) => toDelete(file, 'idCardFront')"
                />
              </template>
            </van-field>
            <van-field name="uploader" label="身份证国徽面">
              <template #input>
                <van-uploader
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'idCardBack')"
                  :before-delete="(file) => toDelete(file, 'idCardBack')"
                  v-model="form.idCardBack"
                />
              </template>
            </van-field>
            <van-field name="uploader" label="营业执照">
              <template #input>
                <van-uploader
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'businessLicense')"
                  :before-delete="(file) => toDelete(file, 'businessLicense')"
                  v-model="form.businessLicense"
                />
              </template>
            </van-field>
            <van-field name="uploader" label="征信报告">
              <template #input>
                <van-uploader
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'creditReport')"
                  :before-delete="(file) => toDelete(file, 'creditReport')"
                  v-model="form.creditReport"
                />
              </template>
            </van-field>
            <van-field name="uploader" label="房产证">
              <template #input>
                <van-uploader
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'propertyCertificate')"
                  :before-delete="
                    (file) => toDelete(file, 'propertyCertificate')
                  "
                  v-model="form.propertyCertificate"
                />
              </template>
            </van-field>
            <van-field name="uploader" label="财务报表">
              <template #input>
                <van-uploader
                  :max-count="1"
                  :after-read="(file) => toUpload(file, 'financialStatement')"
                  :before-delete="
                    (file) => toDelete(file, 'financialStatement')
                  "
                  v-model="form.financialStatement"
                />
              </template>
            </van-field>
            <van-field
              v-model="form.bankCardNumber"
              name="银行卡号"
              label="银行卡号"
              placeholder="银行卡号"
              :rules="[{ required: true, message: '请填写用银行卡号' }]"
            />
            <van-field
              v-model="form.contactPhone"
              name="联系电话"
              label="联系电话"
              placeholder="联系电话"
              :rules="[{ required: true, message: '请填写联系电话' }]"
            />
            <div style="margin: 16px">
              <van-button round block type="info" native-type="submit"
                >提交</van-button
              >
            </div>
          </van-form>
        </div>
        <div class="bg">
          <div></div>
        </div>
      </div>

      <div class="foot"></div>
    </div>
    <div v-show="isEmpty">
      <van-empty description="产品不存在" />
    </div>
  </div>
</template>

<script>
import { getWx } from "@/utils/wxJsSdk.js";
import { getPolicyObj, upLoadToOss } from "@/api/oss.js";
import { simpleUuid } from "@/utils/index";
import * as imageConversion from "image-conversion";
import Vue from "vue";
import {
  Notify,
  Empty,
  Button,
  Field,
  Toast,
  Popup,
  Form,
  Area,
  Uploader,
  DatetimePicker,
} from "vant";
Vue.use(Button);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Empty);
Vue.use(Popup);
Vue.use(Area);
Vue.use(DatetimePicker);
export default {
  created() {
    this.getQuery();
    getPolicyObj().then((res) => {
      console.log("res", res);
      this.policyObj = res;
    });
  },
  data() {
    return {
      form: {
        idCardFront: [],
        idCardBack: [],
        businessLicense: [],
        bankCardNumber: "",
        creditReport: [],
        propertyCertificate: [],
        contactPhone: "",
        financialStatement: [],
      },
      isEmpty: false,
      submitLoading: false,
      // 签名信息
      policyObj: {},
    };
  },
  methods: {
    getQuery() {},
    // 上传文件
    toUpload(file, name) {
      const OSS = require("ali-oss");
      imageConversion.compressAccurately(file.file, 400).then((res) => {
        console.log("res", res);
        let img = new File([res], file.file.name, {
          type: file.file.type,
        });
        let data = new FormData();
        let uudid = simpleUuid();
        let fileName = uudid + "." + res.name.split(".").pop();
        data.append("name", fileName);
        data.append("key", fileName);
        data.append("policy", this.policyObj.policy);
        data.append("OSSAccessKeyId", this.policyObj.accessId);
        data.append("success_action_status", 200);
        data.append("signature", this.policyObj.signature);
        data.append("file", img);
        console.log("data", data);
        upLoadToOss(data).then((resss) => {
          console.log("图片地址：", "https://static.xchengtech.cn/" + fileName);
        });
      });
    },
    // 删除文件
    toDelete(file, name) {
      console.log("file", file);
      console.log("name", name);
    },
    // 提交信息
    onSubmit() {},
    getShareTxt() {
      let desc = "点击立即申请";
      let that = this;
      let url = window.location.href;
      getWx(this.depName).then((res) => {
        window.wx.updateAppMessageShareData({
          title: "车贷申请", // 分享标题
          desc: desc, // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png", // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
  },
};
</script>

<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/supplementInfo/index.vue